`<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-row dense>
            <v-col cols="12">
               <v-card>
                  <v-toolbar dark color="primary">
                     <v-toolbar-title>Corporate Membership Application</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text v-if="loading">
                     Loading...
                  </v-card-text>
                  <v-card-text v-else-if="!memberinfo">
                     Membership profile was not found.
                  </v-card-text>
                  <v-card-text v-else>
                     <v-alert v-if="memberinfo.applcorpstatus === 1" type="info" dense text>
                        Your Corporate upgrade request is under review. Please complete Corporate Experience and Declaration in Membership Information.
                     </v-alert>
                     <v-alert v-else-if="memberinfo.applcorpstatus === 2" type="success" dense text>
                        Your Corporate upgrade request has been approved.
                     </v-alert>
                     <v-alert v-else-if="memberinfo.applcorpstatus === 3" type="warning" dense text>
                        Your previous Corporate upgrade request was rejected. You may submit a new request if required.
                     </v-alert>
                     <v-alert v-if="!canApply && memberinfo.membertype !== 'COR'" type="warning" dense text>
                        Corporate upgrade is available for active Graduate or Associate members only.
                     </v-alert>

                     <v-row dense>
                        <v-col cols="12" md="4">
                           <v-text-field label="Current Member Type" :value="formatType(memberinfo.membertype)" readonly dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                           <v-text-field label="Status" :value="formatStatus(memberinfo.memberstatus)" readonly dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                           <v-text-field label="Member ID" :value="memberinfo.memberid" readonly dense outlined></v-text-field>
                        </v-col>
                     </v-row>

                     <v-form v-if="canApply" v-model="formvalid" lazy-validation>
                        <v-row dense>
                           <v-col cols="12" md="4">
                              <v-text-field v-model="form.course_date" label="Course Date" type="date" dense outlined></v-text-field>
                           </v-col>
                           <v-col cols="12" md="4">
                              <v-text-field v-model="form.interview_date" label="Interview Date" type="date" dense outlined></v-text-field>
                           </v-col>
                           <v-col cols="12" md="4">
                              <v-text-field v-model="form.exam_date" label="Exam Date" type="date" dense outlined></v-text-field>
                           </v-col>
                           <v-col cols="12">
                              <v-textarea v-model="form.notes" label="Notes" dense outlined rows="3"></v-textarea>
                           </v-col>
                           <v-col cols="12">
                              <v-file-input v-model="form.document" label="Attach Support Document" accept=".jpg, .jpeg, .png, .pdf" show-size dense outlined></v-file-input>
                           </v-col>
                        </v-row>
                     </v-form>
                  </v-card-text>
                  <v-card-actions v-if="memberinfo">
                     <v-spacer></v-spacer>
                     <v-btn color="primary" text href="/member/info">
                        Open Membership Information
                     </v-btn>
                     <v-btn v-if="canApply" color="primary" :disabled="submitting" @click="submitUpgrade">
                        Submit Corporate Application
                     </v-btn>
                  </v-card-actions>
               </v-card>
            </v-col>
         </v-row>
      </v-container>
      <v-snackbar v-model="sbmessage" color="blue darken-3" timeout="2500" dark top>
         {{ txtmessage }}
      </v-snackbar>
   </dashboard-layout>
</template>

<script>
const axios = require('axios')
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'

export default {
   name: "MOMApplyCorp",
   components: {
      DashboardLayout,
      BaseBreadcrumb,
   },
   data() {
      return {
         page: { title: "Corporate Apply" },
         breadcrumbs: [
            { text: "Dashboard", disabled: false, to: "/dashboard" },
            { text: "Corporate Apply", disabled: true },
         ],
         user: null,
         memberinfo: null,
         loading: false,
         submitting: false,
         formvalid: false,
         sbmessage: false,
         txtmessage: '',
         form: {
            course_date: '',
            interview_date: '',
            exam_date: '',
            notes: '',
            document: null,
         },
      }
   },
   computed: {
      canApply() {
         return this.memberinfo
            && ['GRA', 'ASC'].includes(this.memberinfo.membertype)
            && parseInt(this.memberinfo.memberstatus) === 3
            && ![1, 2].includes(parseInt(this.memberinfo.applcorpstatus || 0))
      },
   },
   mounted() {
      this.user = this.$page.user
      this.loadMemberInfo()
   },
   methods: {
      loadMemberInfo() {
         this.loading = true
         axios.get('/member/info/' + this.user.id)
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.memberinfo = resp.data.data
            }
         })
         .finally(() => {
            this.loading = false
         })
      },
      submitUpgrade() {
         const data = new FormData()
         data.append('userid', this.memberinfo.userid)
         data.append('course_date', this.form.course_date)
         data.append('interview_date', this.form.interview_date)
         data.append('exam_date', this.form.exam_date)
         data.append('notes', this.form.notes)
         if (this.form.document) {
            data.append('document', this.form.document)
         }

         this.submitting = true
         axios.post('/member/apply/upgrade-corporate', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.memberinfo = resp.data.data
               this.txtmessage = 'Corporate application submitted'
               this.sbmessage = true
            } else if (resp.data) {
               this.txtmessage = resp.data.error
               this.sbmessage = true
            }
         })
         .finally(() => {
            this.submitting = false
         })
      },
      formatType(e) {
         const types = {
            ASC: 'Associate',
            STU: 'Student',
            GRA: 'Graduate',
            COR: 'Corporate',
            FEL: 'Fellow',
            HON: 'Honorary',
            PAT: 'Patron',
         }
         return types[e] || e
      },
      formatStatus(e) {
         const statuses = {
            0: 'Applying',
            1: 'Pending Approval',
            2: 'Pending Payment',
            3: 'Active',
            4: 'Suspended',
            5: 'Deceased',
         }
         return statuses[e] || e
      },
   }
}
</script>
